// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608120600/js/" + chunkId + "." + {"44":"539270b1","225":"94899a1d","481":"11848ae5","486":"05396e2d","770":"9aeeb6eb"}[chunkId] + ".0.24161044743615756.chunk.js";
};